<template>
    <v-container grid-list-md>
        <form v-on:submit.prevent="create">

            <v-layout row wrap>

                <v-flex xs6 s6 md6>
                    <v-text-field
                            v-validate="'required'"
                            v-model="data.name"
                            :error-messages="errors.collect('data.name')"
                            label="Name"
                            data-vv-name="data.name"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex xs6 s6 md6>
                    <v-text-field
                            v-validate="'required|email'"
                            v-model="data.email"
                            :error-messages="errors.collect('data.email')"
                            label="E-mail"
                            data-vv-name="data.email"
                            browser-autocomplete="off"
                    ></v-text-field>
                </v-flex>

                <v-flex>
                    <v-btn large color="secondary" class="text--primary" type="submit">Create Agent</v-btn>
                </v-flex>
                <v-flex xs12 sm12 md12>
                    <v-btn block outline color="red" v-if="message_error">{{ message_error}}</v-btn>
                </v-flex>
            </v-layout>
        </form>
    </v-container>
</template>

<script>
    import { DICCIONARIO } from '../../../diccionario';

    export default {
        data : function() {
            return {
                data : {
                    email : '',
                    name: ''
                },
                error : false,
                message_error : null,
                dictionary: DICCIONARIO
            }
        },
        created () {
            this.setSectionTitle();
        },
        mounted () {
            this.$validator.localize('en', this.dictionary)
        },
        methods: {
            setSectionTitle () {
                this.$store.dispatch('setSectionTitle', {
                    title: 'Create agent.'
                });
            },
            create : function() {
                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.error_login = false;
                        this.message_error_login = '';

                        //dispatch the login and catch the response with the promise declared in vuex Authmodule
                        this.$store.dispatch('createAgent', {
                            data : this.data
                        }).then((res) => {

                            this.$router.push({ name : 'admin.agents.list'});

                        }).catch((error) => {
                            //if incorrect we show a message
                            this.message_error = error.data.errors.email[0];
                        });
                    }
                });

            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/agents/CreateComponent.vue